import { Box } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import { MemoizedFooter } from "../../src/layouts/footer";
import { MemoizedHeader } from "../../src/layouts/header";
import { MemoizedHappyCustomers } from "../../src/pages/HappyCustomers/HappyCustomers";
import { sendAnalytics } from "../../src/utils/analyticsCommon";
import BookEVConsultationForm from "../../src/modules/Home/BookEVconsult/bookEVConsultation";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";

const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Happy Customers" },
];

const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Happy Customers",
      item: "https://www.turno.club/happycustomers",
    },
  ],
};

export default function HappyCustomers() {
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: "HappyCustomers_Screen" },
      "en"
    );
  }, []);

  return (
    <>
      <Head>
        <title>Happy Customers | Turno</title>
        <link rel="canonical" href="https://www.turno.club/happycustomers" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>
      <Box style={{ maxWidth: "480px", margin: "0px auto" }}>
        <MemoizedHeader />
        <MemoizedHappyCustomers />
        <BookEVConsultationForm />
        <Box
          sx={{
            width: { xs: "100%", md: "84%" },
            margin: "20px auto",
            padding: { xs: "0 12px", md: "0" },
          }}
        >
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
        <MemoizedFooter />
      </Box>
    </>
  );
}
